var map = {
	"./az.json": [
		892,
		8
	],
	"./en.json": [
		893,
		9
	],
	"./es-mx.json": [
		894,
		11
	],
	"./es.json": [
		895,
		10
	],
	"./tr.json": [
		896,
		12
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 789;
module.exports = webpackAsyncContext;